import type { CosmeticItem } from '../../api/types';
import { assetUrl } from './cosmeticsMap';
import { LottieLayer, playModeOf, type PlayMode } from './LottieLayer';

/** Раскладка lottie-строк (HANDOFF косметики п.4.2): эффекты по периметру
 *  растягиваются, эффекты у баллов прижимаются к правому краю. */
const RIGHT_ALIGNED = new Set(['row_stack', 'row_fan', 'row_jackpot', 'row_slot', 'row_razdacha']);
/** Ассеты, требующие реверса по времени. «Слот» играет прямо: битые
 *  кейфреймы барабанов (лента уезжала из окна) исправлены в самом .lottie
 *  02.10 — реверс был ложным следом. */
const REVERSED = new Set<string>();
/** Зеркалирование по горизонтали. «Раздача» больше не зеркалится: CSS-flip
 *  отражал и рисунок карты с полосой редкости — полёт к правому краю
 *  перенесён в кейфреймы самого .lottie (02.10, не затирать оригиналом). */
const MIRRORED = new Set<string>();

/** CSS-класс host-строки для косметики: css-строки красятся классом,
 *  lottie-строкам класс включает relative/overflow. */
export function rowFxClass(cosmetic: CosmeticItem | null | undefined): string {
  if (!cosmetic) return '';
  if (cosmetic.kind === 'css') return ` rfx-host rfx-${cosmetic.asset}`;
  if (cosmetic.kind === 'lottie') return ' rfx-host';
  return '';
}

/**
 * Lottie-слой внутри строки списка (вставлять первым ребёнком строки с
 * rowFxClass). Текст строки остаётся поверх (z-index в .rfx-host > *).
 */
export function RowFxLayer({
  cosmetic,
  height = 58,
  mode,
}: {
  cosmetic: CosmeticItem | null | undefined;
  height?: number;
  /** Переопределение режима: превью/предпросмотр играют циклом. */
  mode?: PlayMode;
}) {
  if (!cosmetic || cosmetic.kind !== 'lottie') return null;
  const url = assetUrl(cosmetic.asset);
  if (!url) return null;
  return (
    <LottieLayer
      src={url}
      mode={mode ?? playModeOf(cosmetic.rarity, 'row')}
      className={`rfx-layer${RIGHT_ALIGNED.has(cosmetic.code) ? ' rfx-layer--right' : ''}${MIRRORED.has(cosmetic.code) ? ' rfx-mirror' : ''}`}
      layout={RIGHT_ALIGNED.has(cosmetic.code) ? 'right' : 'fill'}
      reverse={REVERSED.has(cosmetic.code)}
      width={360}
      height={height}
    />
  );
}
